module.exports = __webpack_public_path__ + "080f937ceb5863168b16feeec6ff41cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BYekan/BYekan+.ttf
// module id = 487
// module chunks = 0